import { byEventId, byTimestamp } from './chat-event'
import { byFavorite, byName, byFavoriteThenName, byActiveSession, byOnline, byLastSeen, byRole } from './contact'

export default {
  contacts: {
    byName,
    byFavorite,
    byFavoriteThenName,
    byActiveSession,
    byOnline,
    byLastSeen,
    byRole,
  },
  chatEvents: {
    byEventId,
    byTimestamp,
  },
  byTimestamp,
}
